import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import ArrowLink from "../molecules/ArrowLink";
export default function TwoColAngleBlock(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "page-container-lg mb-12 md:mb-20 relative overflow-hidden"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-5xl angle-teaser-inner"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "mx-auto mb-5 md:pb-2 text-center font-medium max-w-xs md:max-w-md lg:max-w-3xl block text-2xl md:text-3xl lg:text-4xl"
    }, props.heading), props.ctas ? /*#__PURE__*/ React.createElement("div", {
        className: "md:flex flex-col md:flex-row md:items-start md:gap-x-4 justify-center mb-10 lg:mb-20"
    }, props.ctas.filter(function(item) {
        return item === null || item === void 0 ? void 0 : item.label;
    }).map(function(cta, key) {
        /*#__PURE__*/ return React.createElement("a", {
            key: key,
            href: cta === null || cta === void 0 ? void 0 : cta.target,
            className: clsx("block w-auto mb-4 md:mb-5 lg:mb-0", {
                "button-secondary focus bg-gray-30 border-gray-600 text-gray-600 hover:bg-blue-500 hover:border-blue-500 hover:text-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "PRIMARY",
                "button-secondary border-gray-600 text-white bg-gray-600 hover:bg-blue-500 hover:border-blue-500": (cta === null || cta === void 0 ? void 0 : cta.display) === "SECONDARY"
            })
        }, cta === null || cta === void 0 ? void 0 : cta.label);
    })) : null, /*#__PURE__*/ React.createElement("div", {
        className: 'max-[1023px]:border-t-2 max-[1023px]:border-t-[#9ecfdf] relative before:lg:content-[""] before:lg:block before:w-0.5 before:bg-[#9ecfdf] before:absolute before:top-[120px] before:-left-[119px] before:h-56 after:lg:content-[""] after:lg:block after:lg:w-[165px] after:lg:h-0.5 after:lg:bg-[#9ecfdf] after:lg:origin-left after:lg:-rotate-[44deg] after:lg:absolute after:lg:top-[120px] after:lg:-left-[118px]'
    }, /*#__PURE__*/ React.createElement("div", {
        className: 'pt-2 md:pt-6 lg:pt-11 md:grid md:grid-cols-2 md:gap-x-8 before:lg:content-[""] before:lg:block before:lg:w-full before:lg:h-2 before:lg:absolute before:lg:top-0 before:lg:left-0 before:lg:border-b-2 before:lg:border-b-[#9ecfdf]'
    }, props.angleTeasers && props.angleTeasers.filter(function(item) {
        return item === null || item === void 0 ? void 0 : item.title;
    }).map(function(teaser, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: "max-[767px]:border-b last:border-0 border-b-gray-400 ".concat(index < props.angleTeasers.length - 2 ? "border-b pb-2" : "")
        }, /*#__PURE__*/ React.createElement("div", {
            className: "pt-6"
        }, /*#__PURE__*/ React.createElement("h3", {
            className: "text-2xl font-medium mb-2 md:mb-3"
        }, /*#__PURE__*/ React.createElement("a", {
            href: teaser.linkUrl
        }, teaser.title)), /*#__PURE__*/ React.createElement("div", {
            className: "mb-5 md:mb-0 text-gray-600 content-text lg:text-lg"
        }, /*#__PURE__*/ React.createElement(Html, {
            markup: teaser.content
        }))));
    }))), props.moreLinkUrl && props.moreLinkText ? /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-end mt-7"
    }, /*#__PURE__*/ React.createElement(ArrowLink, {
        text: props.moreLinkText,
        target: props.moreLinkUrl,
        className: ""
    })) : null));
}
